import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Impressum() {
	return (
		<div className="page-layout">
			<Header title="Impressum" />

			{/* Hero Section */}
			<section className="hero-section bg-light py-5">
				<div className="container">
					<div className="row">
						<div className="col-lg-8">
							<h1 className="display-4 fw-bold mb-3">Impressum</h1>
							<p className="lead mb-4">Angaben gemäß § 5 TMG</p>
						</div>
					</div>
				</div>
			</section>

			<section className="py-5">
				<div className="container">
					<div className="row">
						<div className="col-12">
							<div className="content-body">
								<div className="row mb-4">
									<div className="col-md-6">
										<div className="bg-light rounded p-4 h-100">
											<h3 className="h5 text-primary fw-bold mb-3">Thankwich</h3>
											<p className="mb-1">Sebastian Jonas (Einzelunternehmer)</p>
											<p className="mb-1">Neue Str. 17B</p>
											<p className="mb-0">30974 Wennigsen</p>
										</div>
									</div>
									<div className="col-md-6">
										<div className="bg-light rounded p-4 h-100">
											<h3 className="h5 text-primary fw-bold mb-3">Kontakt</h3>
											<p className="mb-0">E-Mail: thankwich@rosch.io</p>
										</div>
									</div>
								</div>

								<div className="bg-light rounded p-4 mb-4">
									<h3 className="h5 text-primary fw-bold mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
									<p className="mb-0">
										Sebastian Jonas
										<br />
										Neue Str. 17B
										<br />
										30974 Wennigsen
									</p>
								</div>

								<div className="row">
									<div className="col-lg-4 col-md-6">
										<div className="bg-light rounded p-4 h-100">
											<h3 className="h5 text-primary fw-bold mb-3">Haftung für Inhalte</h3>
											<p className="mb-0 small">Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
										</div>
									</div>
									<div className="col-lg-4 col-md-6">
										<div className="bg-light rounded p-4 h-100">
											<h3 className="h5 text-primary fw-bold mb-3">Haftung für Links</h3>
											<p className="mb-0 small">Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.</p>
										</div>
									</div>
									<div className="col-lg-4 col-md-12">
										<div className="bg-light rounded p-4 h-100">
											<h3 className="h5 text-primary fw-bold mb-3">Urheberrecht</h3>
											<p className="mb-0 small">Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</div>
	);
}

export default Impressum;
